import { BrandInterface, BrandThemeInterface, DefaultTheme } from "@swivl-mono/types";
import { Panel, ColorSwatch } from "@swivl-mono/ui";
import { BrandColorRow } from "./BrandColorRow";

interface Props {
	brand: BrandInterface;
	onColorChange: (name: string, color?: string) => void;
	label: string;
	colors: { label: string, key: keyof BrandThemeInterface }[];
}

function ColorForBrand(brand: BrandInterface, colorName: keyof BrandThemeInterface) {
	if (brand.theme[colorName]) {
		return brand.theme[colorName]!;
	}
	if (DefaultTheme[colorName]) {
		return DefaultTheme[colorName]!;
	}
	return '#000000';
}

export function BrandColorPanel(props: Props) {
	const { brand, onColorChange, label, colors } = props;
	return <Panel
		className="mb-4"
		header={<>
			{label}
		</>}
		headerRight={<div className="flex-1 ml-2 mb-0 flex flex-row items-center justify-end ">
			{colors.map((color, i) => <ColorSwatch className="ml-1" key={i} color={ColorForBrand(brand, color.key)} name={color.key} />)}

		</div>}
	>
		{colors.map((color, i) => <BrandColorRow
			key={i}
			label={color.label}
			color={ColorForBrand(brand, color.key)}
			name={color.key}
			onColorChange={onColorChange}
		/>)}
	</Panel>
}